export default {
  SET_USERS(state, data) {
    state.users = data;
  },
  SET_PAGING(state, data) {
    state.pageable = data;
  },
  RESET_STATE (state, data) {
    Object.assign(state, data)
  },
};
